import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import {
  baseUrl,
  getAppUrlDetailsEndPoint,
  getDataEndPoint,
  getGoogleAuthDetailsEndPoint,
  getPublisherPreloadDataEndPoint,
  getPublisherResponseDataEndPoint,
  sendEmailOnPublisherCreationDataEndPoint,
  updateDataEndPoint,
} from "app/utils/constants/paths";
import uuid from "react-uuid";
import {
  PublisherCrmsAssocData,
  PublisherPlacementAssocData,
  multipleSelectValues,
  publisherCrmsAssocData,
  publisherPlacementAssocData,
  PublisherEmailData,
  addslashes,
} from "app/utils/utils";

import { CountryListArrOfObj } from "app/components/publishers/AppValidation";
import { inventoryFields } from "app/utils/constants/configurations";
import cloneDeep from "lodash.clonedeep";
import { DATASOURCE_CONFIG } from "app/config";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  publishersList: [],
  publisherDetails: {
    account: "",
    name: "",
    email: "",
    supportEmail: "",
    qps: "",
    seatType: "",
    integrationType: "",
    auctionType: "",
    OverrideDynamicFloors: 0,
    floors: [],
    crms: [],
    inventories: [],
    emailInfo: [],
    pub_code: "",
    whitelist_advertisers: "",
    blacklist_advertisers: "",
    whitelist_dsp: "",
    blacklist_dsp: "",
  },
  publisherFilterFormValues: {
    accounts: [],
    publishers: [],
  },
  publisherFilters: {
    accounts: [],
    publishers: [],
  },
  preloadDataFlag: false,
  demandSourceList: [],
};

export const GetAllPublishersListThunk = createAsyncThunk(
  "company/GetAllPublishersListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userProfile = payload?.authUserData?.user_assoc_profiles;
    var publisherFilters = payload?.publisherFilters;
    let condition = [];

    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "p.name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
    }

    if (publisherFilters?.accounts.length > 0) {
      condition.push(
        "p.accountid IN ('" + publisherFilters?.accounts.join("','") + "')"
      );
    }

    if (publisherFilters?.publishers.length > 0) {
      //let advStr = "'"+campaignFilters.advertisers.join("','")+"'";
      condition.push(
        "p.id IN ('" + publisherFilters?.publishers.join("','") + "')"
      );
    } else if (isSysAdmin != 1) {
      if (
        userProfile.includes("publisher") &&
        payload?.authUserData?.user_assoc_publishers.length > 0
      ) {
        condition.push(
          "p.id IN ('" +
            payload?.authUserData?.user_assoc_publishers.join("','") +
            "')"
        );
      } else {
        condition.push("p.id  IN ('0')");
      }
    }
    let where = "";
    condition.push("p.active in ('0','1') and p.accountid=a.id");
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }

    const queryBody = {
      queries: [
        {
          query:
            "select p.id,p.name,p.pub_code,p.email,p.accountid,p.creation_date,a.name as account_name,a.company as account_company_name,p.active from " +
            tablePrefix +
            "publishers as p, " +
            tablePrefix +
            "accounts as a " +
            where +
            " order by p.creation_date desc;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetPublisherDetailsThunk = createAsyncThunk(
  "company/GetPublisherDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select p.*,acnt.seller_account_id from " +
            tablePrefix +
            "publishers p, accounts acnt where p.id='" +
            payload.id +
            "' and p.active='1' and p.accountid=acnt.id",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select id,pub_id,crm_source_id,crm_credentials from " +
            tablePrefix +
            "crm_sources_pub_assoc where pub_id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "SELECT pa.* FROM " +
            tablePrefix +
            "publisher_apps as pa LEFT JOIN " +
            tablePrefix +
            "publishers as p ON pa.pub_code = p.pub_code where p.id='" +
            payload.id +
            "' and  p.active='1' and pa.status='1'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "SELECT pp.* FROM " +
            tablePrefix +
            "publisher_placements as pp LEFT JOIN " +
            tablePrefix +
            "publishers as p ON pp.pub_code  = p.pub_code where p.id='" +
            payload.id +
            "' and is_deleted='0'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "SELECT pra.* FROM " +
            tablePrefix +
            "publisher_request_auth as pra LEFT JOIN " +
            tablePrefix +
            "publishers as p ON pra.pub_code  = p.pub_code where p.id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAppUrlDetailsThunk = createAsyncThunk(
  "company/GetAppUrlDetailsThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getAppUrlDetailsEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetGoogleAuthDetailsThunk = createAsyncThunk(
  "company/GetGoogleAuthDetailsThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getGoogleAuthDetailsEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdatePublisherDetailsThunk = createAsyncThunk(
  "company/InsertUpdatePublisherDetailsThunk",
  async (payload) => {
    let insertUpdateQuery = "";
    let queriesArr = [];
    if (payload.action == "add") {
      let id = payload.id;
      let pub_code = payload.pub_code;
      let accountid = payload.account;
      let crmsAssocInfo = PublisherCrmsAssocData(payload.crms, id, accountid);
      payload.crms = crmsAssocInfo["info"];
      let appAssocInfo = PublisherPlacementAssocData(
        payload.inventories,
        id,
        pub_code,
        accountid
      );
      payload.inventories = appAssocInfo["info"];

      console.log("appAssocInfo", appAssocInfo);
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "publishers (id,name,pub_code,accountid,email,support_email,is_seat_on_platform,whitelist_dsp,blacklist_dsp,whitelist_advertisers,blacklist_advertisers,created_by,creation_date,integration_type,auction_type,override_incoming_floors,floors,qps) values ('" +
        id +
        "','" +
        addslashes(payload.name) +
        "','" +
        pub_code +
        "','" +
        payload.account +
        "','" +
        addslashes(payload.email) +
        "','" +
        addslashes(payload.supportEmail) +
        "','" +
        payload.seatType +
        "','" +
        payload.whitelist_dsp +
        "','" +
        payload.blacklist_dsp +
        "','" +
        payload.whitelist_advertisers +
        "','" +
        payload.blacklist_advertisers +
        "','" +
        payload.created_by +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",'" +
        payload.integrationType +
        "','" +
        payload.auctionType +
        "','" +
        payload.override_incoming_floors +
        "','" +
        payload.floors +
        "','" +
        payload.qps +
        "')";
      let publisherQuery = [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
      let emailAssocInfo = PublisherEmailData(payload.emailInfo, pub_code);
      payload.emailInfo = emailAssocInfo["info"];

      console.log("emailAssocInfo", emailAssocInfo);

      let allQueries = [
        ...publisherQuery,
        ...crmsAssocInfo["query"],
        ...appAssocInfo["query"],
        ...emailAssocInfo["query"],
      ];
      queriesArr = allQueries;
    } else {
      let id = payload.id;
      let pub_code = payload.pub_code;
      let accountid = payload.account;

      let crmsAssocInfo = PublisherCrmsAssocData(payload.crms, id, accountid);
      payload.crms = crmsAssocInfo["info"];
      let appAssocInfo = PublisherPlacementAssocData(
        payload.inventories,
        id,
        pub_code,
        payload.account
      );
      payload.inventories = appAssocInfo["info"];
      console.log("appAssocInfo", appAssocInfo);
      let emailAssocInfo = PublisherEmailData(payload.emailInfo, pub_code);
      payload.emailInfo = emailAssocInfo["info"];
      console.log("emailAssocInfo", emailAssocInfo);
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "publishers set name='" +
        addslashes(payload.name) +
        "',email='" +
        addslashes(payload.email) +
        "',support_email='" +
        addslashes(payload.supportEmail) +
        "',is_seat_on_platform='" +
        payload.seatType +
        "',whitelist_advertisers='" +
        payload.whitelist_advertisers +
        "',blacklist_advertisers='" +
        payload.blacklist_advertisers +
        "',whitelist_dsp='" +
        payload.whitelist_dsp +
        "',blacklist_dsp='" +
        payload.blacklist_dsp +
        "',integration_type='" +
        payload.integrationType +
        "',auction_type='" +
        payload.auctionType +
        "',override_incoming_floors='" +
        payload.override_incoming_floors +
        "',floors='" +
        payload.floors +
        "',qps='" +
        payload.qps +
        "' where id='" +
        id +
        "'";
      let publisherQuery = [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];

      let allQueries = [
        ...publisherQuery,
        ...crmsAssocInfo["query"],
        ...appAssocInfo["query"],
        ...emailAssocInfo["query"],
      ];
      queriesArr = allQueries;
    }

    console.log("queriesArr", queriesArr);

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdatePublisherStatusThunk = createAsyncThunk(
  "publisher/UpdatePublisherStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "publishers set active='" +
            payload.status +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetPublisherPreloadDataThunk = createAsyncThunk(
  "publisher/GetPublisherPreloadDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getPublisherPreloadDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const sendEmailOnPublisherCreationThunk = createAsyncThunk(
  "publisher/sendEmailOnPublisherCreationThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        sendEmailOnPublisherCreationDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getPublisherResponseDataThunk = createAsyncThunk(
  "publisher/getPublisherResponseDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getPublisherResponseDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Publisher = createSlice({
  name: "publisher",
  initialState,
  reducers: {
    resetPublisherForm(state, action) {
      state.publisherDetails = {
        account: "",
        name: "",
        email: "",
        supportEmail: "",
        qps: "",
        seatType: 0,
        integrationType: 1,
        auctionType: 1,
        OverrideDynamicFloors: 0,
        floors: [],
        crms: [],
        inventories: [],
        emailInfo: [],
        pub_code: "",
        whitelist_advertisers: "",
        blacklist_advertisers: "",
        whitelist_dsp: "",
        blacklist_dsp: "",
      };
    },
    updatePublisherFiltersFormValues(state, action) {
      let publisherFilters = cloneDeep(state.publisherFilterFormValues);
      if (action.payload?.action == "delete") {
        publisherFilters = {
          accounts: [],
          publishers: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        publisherFilters[type] = data;
      }

      state.publisherFilterFormValues = publisherFilters;
    },
    updatePublisherFilters(state, action) {
      let publisherFilters = cloneDeep(state.publisherFilters);
      publisherFilters.accounts = action.payload.accounts;
      publisherFilters.publishers = action.payload.publishers;

      state.publisherFilters = publisherFilters;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllPublishersListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllPublishersListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.publishersList = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(GetAllPublishersListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(GetPublisherDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPublisherDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0].length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let crmResultData = action.payload.data?.results[1];
          let appResultData = action.payload.data?.results[2];
          let placementResultData = action.payload.data?.results[3];
          let emailResultData = action.payload.data?.results[4];

          let crmData = [];

          crmResultData.map((info) => {
            let credentialParse = JSON.parse(info.crm_credentials);
            let crmInfo = {
              id: info.id,
              crmId: info.crm_source_id,
              creditionalJson: credentialParse.credential_json,
              databaseUrl: credentialParse.db_url,
              tableName: credentialParse.table_ref,
              delete: false,
            };
            crmData.push(crmInfo);
          });

          let appData = [];

          appResultData.map((appInfo) => {
            console.log("appdetails", appInfo.app_details);
            let appdata =
              appInfo.app_details != "" && appInfo.app_details != null
                ? JSON.parse(appInfo.app_details)
                : "";
            let aInfo = {
              id: appInfo.id,
              app: appInfo.type,
              appUrl: appInfo.url,
              details: appdata,
              delete: false,
              placementInfo: [],
            };

            placementResultData.map((placeInfo) => {
              if (appInfo.id == placeInfo.pub_app_id) {
                let pinfo = {
                  id: placeInfo.id,
                  delete: false,
                  placementName: placeInfo.name,
                  partnerTagId: placeInfo.partner_tag_id,
                  countryWiseInfo: [],
                };
                let countryFloors = placeInfo.floors;
                if (countryFloors != "") {
                  countryFloors = JSON.parse(placeInfo.floors);

                  countryFloors != "" &&
                    Object.keys(countryFloors).map((cInfo) => {
                      let floorInfo = {
                        country: cInfo.split(","),
                        adSizes: countryFloors[cInfo],
                      };
                      pinfo.countryWiseInfo.push(floorInfo);
                    });
                }

                aInfo.placementInfo.push(pinfo);
              }
            });

            appData.push(aInfo);
          });

          let emailData = [];

          emailResultData.map((info) => {
            let emailAuth = JSON.parse(info.email_auth);
            emailAuth["id"] = info.id;
            emailData.push(emailAuth);
          });

          let pubCountryWiseFloorInfo = [];
          let pubCountryFloors = resultData.floors;
          if (pubCountryFloors != "" && pubCountryFloors != null) {
            pubCountryFloors = JSON.parse(pubCountryFloors);

            pubCountryFloors != "" &&
              Object.keys(pubCountryFloors).map((cInfo) => {
                let floorInfo = {
                  country: cInfo.split(","),
                  adSizes: pubCountryFloors[cInfo],
                };
                pubCountryWiseFloorInfo.push(floorInfo);
              });
          }

          let publisherInfo = {
            account: resultData.accountid,
            name: resultData.name,
            email: resultData.email,
            supportEmail: resultData.support_email,
            qps: resultData.qps,
            seatType: resultData.is_seat_on_platform,
            integrationType: resultData.integration_type,
            auctionType: resultData.auction_type,
            OverrideDynamicFloors: resultData.override_incoming_floors,
            floors: pubCountryWiseFloorInfo,
            pub_code: resultData.pub_code,
            crms: crmData,
            inventories: appData,
            emailInfo: emailData,
            whitelist_advertisers: resultData.whitelist_advertisers,
            blacklist_advertisers: resultData.blacklist_advertisers,
            whitelist_dsp: resultData.whitelist_dsp,
            blacklist_dsp: resultData.blacklist_dsp,
            seller_account_id: resultData.seller_account_id,
          };
          state.publisherDetails = publisherInfo;
        }
        state.loading = false;
      })
      .addCase(GetPublisherDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(InsertUpdatePublisherDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdatePublisherDetailsThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.results.length > 0 &&
          action.payload.data?.results.includes("Updated")
        ) {
          let publisherInfo = {
            account: action.meta.arg.account,
            name: action.meta.arg.name,
            email: action.meta.arg.email,
            supportEmail: action.meta.arg.supportEmail,
            qps: action.meta.arg.qps,
            crms: action.meta.arg.crms,
            inventories: action.meta.arg.inventories,
            emailInfo: action.meta.arg.emailInfo,
            pub_code: action.meta.arg.pub_code,
          };
          state.publisherDetails = publisherInfo;
        }
        //state.loading = false;
      })
      .addCase(InsertUpdatePublisherDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetAppUrlDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAppUrlDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(GetAppUrlDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetGoogleAuthDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetGoogleAuthDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(GetGoogleAuthDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdatePublisherStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdatePublisherStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let pubList = state.publishersList;
          let pubId = action.meta.arg.id;
          let status = action.meta.arg.status;
          pubList.map((pinfo) => {
            if (pinfo.id == pubId) {
              pinfo.active = status;
            }
            return pinfo;
          });
          //pubList = pubList.filter((item) => item.id !== pubId);
          state.publishersList = pubList;
        }
        state.loading = false;
      })
      .addCase(UpdatePublisherStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPublisherPreloadDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPublisherPreloadDataThunk.fulfilled, (state, action) => {
        if (action.payload?.data?.error == false) {
          //state.publishersList = action.payload.data.results[0];
          state.demandSourceList =
            action.payload.data?.result?.bidders_for_targeting;
          state.preloadDataFlag = true;
        }
        state.loading = false;
      })
      .addCase(GetPublisherPreloadDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(sendEmailOnPublisherCreationThunk.pending, (state) => {
        // state.loading = true;
      })
      .addCase(sendEmailOnPublisherCreationThunk.fulfilled, (state, action) => {
        if (action.payload?.data?.error == false) {
        }
        state.loading = false;
      })
      .addCase(sendEmailOnPublisherCreationThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(getPublisherResponseDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPublisherResponseDataThunk.fulfilled, (state, action) => {
        if (action.payload?.data?.error == false) {
        }
        state.loading = false;
      })
      .addCase(getPublisherResponseDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      });
  },
});
const { actions, reducer } = Publisher;
// Extract and export each action creator by name
export const {
  resetPublisherForm,
  updatePublisherFiltersFormValues,
  updatePublisherFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
